import { Header, Footer } from "./Pricing";

export default function Refund() {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-16 prose prose-stone">
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-emerald-700">Legal</div>
        <h1 className="mt-3 font-display text-4xl font-medium text-stone-900">Refund Policy</h1>
        <p className="text-sm text-stone-500">Last updated: February 19, 2026</p>

        <p>ChildCheckOh is a monthly software subscription. We want you to be confident about your purchase, so here's exactly how refunds work.</p>

        <h2>1. 14-day money-back guarantee for first-time subscribers</h2>
        <p>If this is the <b>first time</b> your center has subscribed to ChildCheckOh, you can request a <b>full refund within 14 days</b> of your initial payment — no questions asked. Email <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a> with your account email and we'll process the refund within 5 business days.</p>

        <h2>2. Cancellation at any time</h2>
        <p>You can cancel your subscription any time from your dashboard (<b>Vault Settings → Billing</b>). Cancellation takes effect at the end of your current billing period — you keep access until the period you paid for ends.</p>

        <h2>3. No refunds for partial months</h2>
        <p>After the initial 14-day window, we do not offer pro-rated refunds for partial billing months. This is standard for subscription software.</p>

        <h2>4. Refunds for service failures</h2>
        <p>If the Service experiences an extended outage (more than 48 consecutive hours of downtime in a single billing cycle), you can request a pro-rated credit for the affected period. Email us with the dates and we'll apply credit to your next invoice.</p>

        <h2>5. Refunds for billing errors</h2>
        <p>If you were charged in error (e.g., duplicate charge, charge after cancellation), email us immediately. We'll investigate and refund any erroneous charges within 5 business days.</p>

        <h2>6. How refunds are processed</h2>
        <p>All payments are processed by <b>PayPal</b>. Refunds are returned to the original payment method (PayPal balance, credit card, debit card, or linked bank account). Depending on your bank, the refund may take 5–10 business days to appear on your statement.</p>

        <h2>7. Chargebacks</h2>
        <p>If you have a billing concern, please contact us first at <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a>. We can almost always resolve issues faster than a chargeback. Repeated chargebacks may result in account termination.</p>

        <h2>8. Tax</h2>
        <p>Sales tax, if applicable in your jurisdiction, is collected at checkout by PayPal. Refunds include any tax originally collected.</p>

        <h2>9. How to request a refund</h2>
        <ol>
          <li>Email <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a> from your account email</li>
          <li>Subject line: <code>Refund request — [your center name]</code></li>
          <li>Include the date and amount of the charge (we'll find the rest in our records)</li>
        </ol>
        <p>We respond to refund requests within 1 business day.</p>

        <h2>10. Contact</h2>
        <p><a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a> · ChildCheckOh, Ohio, USA</p>
      </main>
      <Footer />
    </div>
  );
}
